<template>
</template>

<script>
export default {
  name: "Warnings",
  props: ["warningText"],
  mounted() {
    const warningSwal = this.$swal.mixin({
      showCloseButton: true,
      didClose: () => {
        this.$emit("didClose");
      },
    });

    warningSwal.fire({
      icon: "warning",
      timer: 7000,
      text: this.warningText,
      showConfirmButton: false,
    });
  },
};
</script>